/**
 * Dashboard container
 */
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Dashboard from '../../Components/Dashboard/Dashboard';
import { vendorSelector } from '../VendorApplication/selectors';

/**
 * Dashboard properties to be provided to the dashboard console component

 * @param {object} state global state
 */
const mapStateToProps = (state) => ({
  vendor: vendorSelector(state),
});

/**
 * Actions to be dispatched
 *
 * @param {function} dispatch function to dispatch dashboard actions
 */
const mapDispatchToProps = () => ({});

/**
 * Connects dashboard state to the Dashboard Console component

 * @param {object} mapStateToProps dashboard data object to become props for the Dashboard component
 * @param {object} mapDispatchToProps dashboard actions to be dispatched to reducer
 */
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Dashboard),
);
